__turbopack_context__.v({
  "hoverStyleInput": "inputStyles-module__M7vwea__hoverStyleInput",
  "hoverStyleSection": "inputStyles-module__M7vwea__hoverStyleSection",
  "hoverStyleWrapper": "inputStyles-module__M7vwea__hoverStyleWrapper",
  "label": "inputStyles-module__M7vwea__label",
});
